/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssociatedResultTemplate,
    AssociatedResultTemplateFromJSON,
    AssociatedResultTemplateFromJSONTyped,
    AssociatedResultTemplateToJSON,
} from './AssociatedResultTemplate';
import {
    CompetenceTemplate,
    CompetenceTemplateFromJSON,
    CompetenceTemplateFromJSONTyped,
    CompetenceTemplateToJSON,
} from './CompetenceTemplate';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';
import {
    StudyPlan,
    StudyPlanFromJSON,
    StudyPlanFromJSONTyped,
    StudyPlanToJSON,
} from './StudyPlan';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface LearningCompetence
 */
export interface LearningCompetence {
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof LearningCompetence
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningCompetence
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    studyPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    identificator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof LearningCompetence
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetence
     */
    isDomainLearningOutcomeTemplate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    domainLearningOutcomeTemplateId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetence
     */
    isCompetenceTemplate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    competenceTemplateId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetence
     */
    isCompetenceTemplateAssociatedOutcome?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetence
     */
    associatedResultTemplateId?: string | null;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof LearningCompetence
     */
    subjects?: Array<Subject> | null;
    /**
     * 
     * @type {StudyPlan}
     * @memberof LearningCompetence
     */
    studyPlan?: StudyPlan;
    /**
     * 
     * @type {CompetenceTemplate}
     * @memberof LearningCompetence
     */
    competenceTemplate?: CompetenceTemplate;
    /**
     * 
     * @type {AssociatedResultTemplate}
     * @memberof LearningCompetence
     */
    associatedResultTemplate?: AssociatedResultTemplate;
    /**
     * 
     * @type {Array<LearningCompetence>}
     * @memberof LearningCompetence
     */
    learnings?: Array<LearningCompetence> | null;
    /**
     * 
     * @type {Array<LearningCompetence>}
     * @memberof LearningCompetence
     */
    competences?: Array<LearningCompetence> | null;
}

export function LearningCompetenceFromJSON(json: any): LearningCompetence {
    return LearningCompetenceFromJSONTyped(json, false);
}

export function LearningCompetenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'isDomainLearningOutcomeTemplate': !exists(json, 'isDomainLearningOutcomeTemplate') ? undefined : json['isDomainLearningOutcomeTemplate'],
        'domainLearningOutcomeTemplateId': !exists(json, 'domainLearningOutcomeTemplateId') ? undefined : json['domainLearningOutcomeTemplateId'],
        'isCompetenceTemplate': !exists(json, 'isCompetenceTemplate') ? undefined : json['isCompetenceTemplate'],
        'competenceTemplateId': !exists(json, 'competenceTemplateId') ? undefined : json['competenceTemplateId'],
        'isCompetenceTemplateAssociatedOutcome': !exists(json, 'isCompetenceTemplateAssociatedOutcome') ? undefined : json['isCompetenceTemplateAssociatedOutcome'],
        'associatedResultTemplateId': !exists(json, 'associatedResultTemplateId') ? undefined : json['associatedResultTemplateId'],
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
        'studyPlan': !exists(json, 'studyPlan') ? undefined : StudyPlanFromJSON(json['studyPlan']),
        'competenceTemplate': !exists(json, 'competenceTemplate') ? undefined : CompetenceTemplateFromJSON(json['competenceTemplate']),
        'associatedResultTemplate': !exists(json, 'associatedResultTemplate') ? undefined : AssociatedResultTemplateFromJSON(json['associatedResultTemplate']),
        'learnings': !exists(json, 'learnings') ? undefined : (json['learnings'] === null ? null : (json['learnings'] as Array<any>).map(LearningCompetenceFromJSON)),
        'competences': !exists(json, 'competences') ? undefined : (json['competences'] === null ? null : (json['competences'] as Array<any>).map(LearningCompetenceFromJSON)),
    };
}

export function LearningCompetenceToJSON(value?: LearningCompetence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'studyProgramId': value.studyProgramId,
        'studyPlanId': value.studyPlanId,
        'identificator': value.identificator,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'isDomainLearningOutcomeTemplate': value.isDomainLearningOutcomeTemplate,
        'domainLearningOutcomeTemplateId': value.domainLearningOutcomeTemplateId,
        'isCompetenceTemplate': value.isCompetenceTemplate,
        'competenceTemplateId': value.competenceTemplateId,
        'isCompetenceTemplateAssociatedOutcome': value.isCompetenceTemplateAssociatedOutcome,
        'associatedResultTemplateId': value.associatedResultTemplateId,
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
        'studyPlan': StudyPlanToJSON(value.studyPlan),
        'competenceTemplate': CompetenceTemplateToJSON(value.competenceTemplate),
        'associatedResultTemplate': AssociatedResultTemplateToJSON(value.associatedResultTemplate),
        'learnings': value.learnings === undefined ? undefined : (value.learnings === null ? null : (value.learnings as Array<any>).map(LearningCompetenceToJSON)),
        'competences': value.competences === undefined ? undefined : (value.competences === null ? null : (value.competences as Array<any>).map(LearningCompetenceToJSON)),
    };
}

